import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, SHORT_CODES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allShortCode',
  url: `${SHORT_CODES_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
